// frontend/src/utils/crService.js
// ============================================================
// CR MANAGEMENT SERVICE
// Thin wrapper around /api/crs endpoints.
// Mirrors the pattern used in timeTrackingService.js
// ============================================================

import api from './api';

// ============================================================
// HEALTH CHECK
// ============================================================

export const pingCR = async () => {
    const response = await api.get('/api/crs/ping');
    return response.data;
};

// ============================================================
// LIST & DETAIL
// ============================================================

export const listCRs = async (params = {}) => {
    const response = await api.get('/api/crs', { params });
    return response.data;
};

export const getCRById = async (id) => {
    const response = await api.get(`/api/crs/${id}`);
    return response.data;
};

// ============================================================
// CREATE / UPDATE / DELETE
// ============================================================

export const createCR = async (payload) => {
    const response = await api.post('/api/crs', payload);
    return response.data;
};

export const updateCR = async (id, payload) => {
    const response = await api.put(`/api/crs/${id}`, payload);
    return response.data;
};

export const deleteCR = async (id) => {
    const response = await api.delete(`/api/crs/${id}`);
    return response.data;
};

// ============================================================
// TICKET LINKING
// ============================================================

export const linkTickets = async (crId, ticketIds) => {
    const response = await api.post(`/api/crs/${crId}/link-tickets`, { ticketIds });
    return response.data;
};

export const unlinkTicket = async (crId, ticketId) => {
    const response = await api.delete(`/api/crs/${crId}/unlink-ticket/${ticketId}`);
    return response.data;
};

// ============================================================
// TIME ENTRIES
// ============================================================

export const addTimeEntry = async (crId, payload) => {
    const response = await api.post(`/api/crs/${crId}/time-entries`, payload);
    return response.data;
};

export const updateTimeEntry = async (crId, entryId, payload) => {
    const response = await api.put(`/api/crs/${crId}/time-entries/${entryId}`, payload);
    return response.data;
};

export const deleteTimeEntry = async (crId, entryId) => {
    const response = await api.delete(`/api/crs/${crId}/time-entries/${entryId}`);
    return response.data;
};

// ============================================================
// PICKER SUPPORT
// ============================================================

export const getAvailableTickets = async (contractId, search = '') => {
    const response = await api.get('/api/crs/available-tickets', {
        params: { contractId, search }
    });
    return response.data;
};

export const checkCRNumber = async (crNumber) => {
    const response = await api.get('/api/crs/check-number', {
        params: { crNumber }
    });
    return response.data;
};